$(document).ready(function () {
	$('.desktop-nav li').on('click', function () {
		$(this).addClass('active').siblings('li').removeClass('active');
	});

	$('.menu-hamburger').on('click', function () {
		$(this).hide();
		$('.menu').show();
	});

	$('.menu-close').on('click', function () {
		$('.menu').hide();
		$('.menu-hamburger').show();
	});
});
